import { TextField } from "@mui/material";
import { ChangeEvent, CSSProperties, FC } from "react";

interface Props {
  label: string;
  error?: boolean;
  defaultValue?: string;
  autocomplete?: string;
  required?: boolean;
  disabled?: boolean;
  helperText?: string;
  multiline?: boolean;
  rows?: number;
  maxRows?: number;
  minRows?: number;
  inputStyle?: CSSProperties;
  style?: CSSProperties;
  fullWidth?: boolean;
  onChange?: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  color?: "primary" | "secondary" | "success" | "error" | "info" | "warning";
  size?: "small" | "medium";
  margin?: "none" | "dense" | "normal";
  variant?: "outlined" | "filled" | "standard";
  autoFocus?: boolean;
  sx?: CSSProperties;
}

const SpTextInputField: FC<Props> = ({
  label,
  error = false,
  defaultValue = "",
  autocomplete = "off",
  required = false,
  disabled = false,
  helperText = "",
  multiline = false,
  rows = 1,
  minRows = 1,
  maxRows = 1,
  inputStyle,
  style,
  fullWidth = true,
  onChange,
  color = "primary",
  size = "medium",
  margin = "dense",
  variant = "outlined",
  autoFocus = false,
  sx,
}) => {
  return (
    <TextField
      error={error}
      id="outlined-error"
      label={label}
      defaultValue={defaultValue}
      variant={variant}
      required={required}
      disabled={disabled}
      helperText={helperText}
      multiline={multiline}
      rows={rows}
      minRows={minRows}
      maxRows={maxRows}
      style={style}
      fullWidth={fullWidth}
      margin={margin}
      onChange={onChange}
      color={color}
      size={size}
      autoFocus={autoFocus}
      sx={sx}
      inputProps={{ style: inputStyle }}
    />
  );
};

export default SpTextInputField;
